import React from 'react'
import {
  TaskMenuItemContainer,
  TaskMenuItemIcon,
  TaskMenuItemText,
  TaskMenuListItem,
} from './TaskMenu.styles'

type TaskMenuItemProps = {
  onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  icon: JSX.Element
  text: string
}

const TaskMenuItem: React.FC<TaskMenuItemProps> = ({ onClick, icon, text }) => (
  <TaskMenuItemContainer>
    <TaskMenuListItem button onClick={onClick}>
      <TaskMenuItemIcon>{icon}</TaskMenuItemIcon>
      <TaskMenuItemText primary={text} />
    </TaskMenuListItem>
  </TaskMenuItemContainer>
)

export default TaskMenuItem
